import { render } from "./quillTextEditor.vue?vue&type=template&id=f564719c"
import script from "./quillTextEditor.vue?vue&type=script&lang=js"
export * from "./quillTextEditor.vue?vue&type=script&lang=js"

import "./quillTextEditor.vue?vue&type=style&index=0&id=f564719c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__